export enum ProgressBarLabelAlign {
	Full = 'full',
	Left = 'left',
	Right = 'right'
}
